import $ from "jquery";
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class ArticleGrouping extends Component {
    constructor(props) {
        super(props);

        if (!Comm.ValidSession()) return;

        if (!Context.IsLogged()) {
            return;
        }
        var sid = Context.GetContext().Sid;
        var groups = Comm.ArticleGroups(sid);

        var articles = Comm.Articles(sid, true);

        this.state = {
            Groups: groups,
            Articles: articles,
            SelectedGroup: null,
            showError: false,
        };
        
    }

    ShowGroup(group) {
        this.setState({ SelectedGroup: group, showError: false });
    }

    NewGroup() {
        this.setState({ SelectedGroup: { id: null, name: "", articles: [] } });
    }

    GroupHasArticle(articleId, groupArticles) {
        for (var iter = 0; iter < groupArticles.length; iter++) {
            var a = groupArticles[iter];
            if (a.id === articleId) return true;
        }

        return false;
    }

    Save() {
        var gn = $("#tbGroupName").val();
        if (gn === "") {
            this.setState({ showError: true });
            return;
        }

        var sid = Context.IsLogged().Sid;
        var data = {
            name: gn,
        };

        if (this.state.SelectedGroup.id) data.id = this.state.SelectedGroup.id;

        var articles = [];
        $("input[id^='cbArticle']:checked").each(function (i, e) {
            var val = $(e).attr("permvalue");

            articles.push({ id: val });
        });
        sid = Context.GetContext().Sid;

        data.articles = JSON.stringify(articles);
        data.session = sid;

        Comm.SaveArticleGroup(data);

        this.setState({
            Groups: Comm.ArticleGroups(sid),
            SelectedGroup: null,
            showError: false,
        });
    }

    RealDelGroup(id) {
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            id: id,
        };
        Comm.DeleteArticleGroup(data);
        this.setState({
            Groups: Comm.ArticleGroups(sid),
            SelectedGroup: null,
            showError: false,
        });
    }

    DelGroup(id) {
        if(window.confirm(Translation.Trans("pleaseconfirm"))){
            this.RealDelGroup(id);
        }
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }
        var ctx = Context.GetContext();
        if (ctx == null || Comm.SessionUser(ctx.Sid).errcode > 0) {
            this.props.history.push("/login");
            return null;
        }

        var groups = this.state.Groups.slice();

        var self = this;

        return Context.HasRight("rarticlegrouping") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("goodgrouping")}</div>
                <div className="panel-body">
                    {Context.HasRight("earticlegrouping") ? (
                        <button className="btn btn-primary" onClick={() => this.NewGroup()}>
                            {Translation.Trans("newgrouping")}
                        </button>
                    ) : null}
                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-4">
                            {groups.map((obj) => (
                                <p>
                                    <button className="btn btn-info" onClick={() => self.DelGroup(obj.id)}>
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                    <span
                                        className={
                                            this.state.SelectedGroup != null &&
                                            this.state.SelectedGroup.id === obj.id
                                                ? "btn btn-warning"
                                                : null
                                        }
                                    >
                                        <a onClick={() => this.ShowGroup(obj)} className="pointhand">
                                            {obj.name}
                                        </a>
                                    </span>
                                </p>
                            ))}
                        </div>
                        <div className="col-md-8">
                            {this.state.SelectedGroup !== null ? (
                                <div id="dData" className="borderDiv">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {Context.HasRight("earticlegrouping") ? (
                                                <button
                                                    className="btn btn-primary pull-right"
                                                    onClick={() => this.Save()}
                                                >
                                                    {Translation.Trans("save")}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={Translation.Trans("groupname")}
                                                id="tbGroupName"
                                                defaultValue={this.state.SelectedGroup.name}
                                                key={this.state.SelectedGroup.id}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            {this.state.showError ? (
                                                <div className="alert alert-danger">
                                                    {Translation.Trans("entervalue")}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            {this.state.Articles.map((obj) => (
                                                <div className="checkbox">
                                                    <input
                                                        id={"cbArticle_" + obj.id}
                                                        type="checkbox"
                                                        permvalue={obj.id}
                                                        key={obj.id + "_" + this.state.SelectedGroup.id}
                                                        defaultChecked={this.GroupHasArticle(
                                                            obj.id,
                                                            this.state.SelectedGroup.articles
                                                        )}
                                                    />
                                                    <label for={"cbArticle_" + obj.id}>{obj.name}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default ArticleGrouping;



// WEBPACK FOOTER //
// ./src/pages/articlegrouping.js